import { defaultTransformation } from './default-transformation';
import { tableChartTransformation } from './charts';
export var transformCategoricalChronological = function (_a, _b, visualization) {
    var query = _a.query, result = _a.result;
    var mergePropertiesOrder = _b.mergePropertiesOrder, fillEmptyIntervalsKeys = _b.fillEmptyIntervalsKeys, dateModifier = _b.dateModifier;
    var enableTableFormatter = (query === null || query === void 0 ? void 0 : query.analysis_type) && (query === null || query === void 0 ? void 0 : query.event_collection) &&
        visualization === 'table';
    return enableTableFormatter
        ? tableChartTransformation({ query: query, result: result }, { fillEmptyIntervalsKeys: fillEmptyIntervalsKeys, dateModifier: dateModifier })
        : defaultTransformation(result, {
            mergePropertiesOrder: mergePropertiesOrder,
            fillEmptyIntervalsKeys: fillEmptyIntervalsKeys,
            dateModifier: dateModifier,
        });
};
